import { useGetAddressType } from "@common/hook/useGetAddressType";
import { EADDRESS_TYPES } from "@constants";
import { ReplacementSimAddressForm } from "./ReplacementSimAddressForm";
import { useGetUserContact } from "../Profile/UserDetails/hooks/useGetUserContact";
import { HandleErrorAndLoading } from "@common/handleErrorAndLoading/HandleErrorAndLoading";

interface IParams {
    closeForm(): void;
    displaySnackbar(): void;
    getSimReplacePending: () => void;
}

export const ReplacementSimAddress = (props: IParams) => {
    const { closeForm, displaySnackbar, getSimReplacePending } = props;

    const { getUserAddress, addressField, getUserAddressState } = useGetAddressType(EADDRESS_TYPES.BILLING);
    const { userDetails, getUserDetailsState, getUserDetails } = useGetUserContact();

    const error = getUserAddressState.error ?? getUserDetailsState.error;
    const isLoading = getUserAddressState.isLoading ?? getUserDetailsState.isLoading;
    const retryFetch = getUserAddressState.error ? getUserAddress : getUserDetails;

    return (
        <HandleErrorAndLoading error={error} isLoading={isLoading} retryFetch={retryFetch}>
            {addressField && (
                <ReplacementSimAddressForm
                    closeForm={closeForm}
                    deliveryAddress={addressField}
                    displaySnackbar={displaySnackbar}
                    userDetails={userDetails}
                    getSimReplacePending={getSimReplacePending}
                />
            )}
        </HandleErrorAndLoading>
    );
};
